import { render } from "./AppContentButtonsComponent.vue?vue&type=template&id=72d4f0ad&scoped=true&ts=true"
import script from "./AppContentButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./AppContentButtonsComponent.vue?vue&type=script&lang=ts"

import "./AppContentButtonsComponent.vue?vue&type=style&index=0&id=72d4f0ad&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d4f0ad"]])

export default __exports__